export const getCrossHeaders = (tenantId) => {
  const [siteId, countryCode] = tenantId.split('-');
  return {
    'x-site-id': siteId,
    'x-tenant-id': countryCode,
    'User-Agent': `FalabellaBrowse/falabella-b2c-ui:1.0.0 (Web; ${tenantId})`,
  };
};
